/**
 * Teamwear Calculator JavaScript
 * Handles all interactions and cart integration
 */

class TeamwearCalculator {
  constructor(sectionId) {
    this.section = document.querySelector(`[data-section="${sectionId}"]`);
    if (!this.section) return;
    
    this.config = window.teamwearConfig || {};
    this.productCache = {};
    this.isInitialLoad = true;  // Flag um initiales Laden von User-Klick zu unterscheiden
    
    this.state = {
      selectedProduct: null,
      selectedVariantId: null,
      selectedColor: null,
      selectedQuantity: 0,
      selectedDiscount: 0,
      basePrice: 0,
      finalPrice: 0,
      discountSettings: null,
      productVariants: [],
      productImages: [],
      availableColors: [],
      personalization: [],
      teamLogo: null,
      teamName: ''
    };
    
    this.elements = {
      designs: this.section.querySelectorAll('.teamwear-design__input'),
      colorSelection: this.section.querySelector('.teamwear-color-selection'),
      colorsContainer: this.section.querySelector('.teamwear-colors'),
      colorsPlaceholder: this.section.querySelector('.teamwear-colors__placeholder'),
      colorPreviewImage: this.section.querySelector('[data-color-preview]'),
      colorThumbnails: this.section.querySelector('[data-color-thumbnails]'),
      colorNavPrev: this.section.querySelector('[data-color-nav="prev"]'),
      colorNavNext: this.section.querySelector('[data-color-nav="next"]'),
      colorZoomBtn: this.section.querySelector('[data-color-zoom-trigger]'),
      teamSection: this.section.querySelector('.teamwear-team-section'),
      teamLogoInput: this.section.querySelector('[data-team-logo]'),
      teamNameInput: this.section.querySelector('[data-team-name]'),
      quantitySection: this.section.querySelector('.teamwear-quantity-section'),
      quantityInput: this.section.querySelector('[data-quantity-input]'),
      personalizationContent: this.section.querySelector('.teamwear-personalization__content'),
      personalizationList: this.section.querySelector('[data-players-body]'),
      totalPrice: this.section.querySelector('[data-total-price]'),
      priceDetails: this.section.querySelector('[data-price-details]'),
      submitButton: this.section.querySelector('.teamwear-submit'),
      messages: this.section.querySelector('.teamwear-messages')
    };
    
    this.init();
  }
  
  init() {
    this.preloadAllProducts();
    this.attachEventListeners();
    this.initializeDynamicDiscounts();
    
    // Keine automatische Vorauswahl - User muss aktiv wählen
    // Die Farbauswahl bleibt ausgeblendet bis ein Design gewählt wird
    
    // Nach initialem Laden Flag auf false setzen
    setTimeout(() => {
      this.isInitialLoad = false;
    }, 500);
    
    this.updateUI();
  }
  
  initializeDynamicDiscounts() {
    this.state.useDynamicDiscounts = this.section.dataset.useDynamicDiscounts === 'true';
    this.state.maxDiscountLimit = parseInt(this.section.dataset.maxDiscountLimit) || 25;
    
    try {
      const tiersData = this.section.dataset.discountTiers;
      if (tiersData) {
        this.state.discountTiers = JSON.parse(tiersData.trim().replace(/&quot;/g, '"'));
        if (!Array.isArray(this.state.discountTiers)) throw new Error('Invalid tiers');
        this.state.discountTiers.sort((a, b) => b.quantity - a.quantity);
        if (!this.state.useDynamicDiscounts && this.state.discountTiers.length > 0) {
          this.state.useDynamicDiscounts = true;
        }
      }
    } catch (error) {
      console.error('Error parsing discount tiers:', error);
      this.state.useDynamicDiscounts = false;
      this.state.discountTiers = [];
    }
  }
  
  attachEventListeners() {
    this.initDesignImageSliders();
    
    // Design selection - SOFORTIGES visuelles Feedback!
      this.elements.designs.forEach(input => {
        input.addEventListener('change', (e) => {
          const target = e.target;
        if (!(target instanceof HTMLInputElement && target.checked)) return;
        
        // Nur bei echtem User-Klick scrollen (nicht bei programmatischem Aufruf)
        this.userClickedDesign = e.isTrusted;
        
        // NUR State-Update - KEINE DOM-Operationen! Radio-Button wird durch CSS sofort visuell angezeigt
        const productId = target.dataset.productId;
        const productHandle = target.dataset.productHandle;
        const productType = target.dataset.productType || 'Trikot';
        if (!productId || !productHandle) return;

        this.state.selectedProductType = productType;
        this.state.selectedProduct = { id: productId, handle: productHandle, type: productType, name: '' };
        this.state.selectedColor = null;
        this.state.selectedVariantId = null;
            this.state.basePrice = parseFloat(target.dataset.basePrice) || 0;
            this.state.discountSettings = {
              discountPerTier: parseInt(target.dataset.discountPerTier) || 5,
              tierSize: parseInt(target.dataset.tierSize) || 10,
              maxDiscount: parseInt(target.dataset.maxDiscount) || 50
            };
            
        // SOFORT Ladezeichen anzeigen - ohne Verzögerung!
        this.showColorLoading();
        
        // Alle DOM-Operationen komplett asynchron - Event-Handler ist fertig!
        Promise.resolve().then(() => {
          console.log('=== DESIGN AUSGEWÄHLT ===');
          console.log('Product Handle:', productHandle);
          console.log('Product ID:', productId);
          console.log('Im Cache?:', !!this.productCache[productHandle]);
          
          const designElement = target.closest('.teamwear-design');
          if (designElement) {
            const firstImage = designElement.querySelector('.teamwear-design__image');
            if (firstImage && this.elements.colorPreviewImage) {
              this.elements.colorPreviewImage.src = firstImage.src;
              this.elements.colorPreviewImage.alt = firstImage.alt;
            }
            const nameElement = designElement.querySelector('.teamwear-design__name');
            if (nameElement) this.state.selectedProduct.name = nameElement.textContent;
          }

          // Texte basierend auf Produkttyp dynamisch updaten
          this.updateProductTypeTexts();
          
          // Bilder mit Alt-Text aus dem data-Attribut holen (Liquid liefert diese)
          const imagesJson = target.dataset.productImages;
          if (imagesJson) {
            try {
              this.state.liquidProductImages = JSON.parse(imagesJson);
              console.log('Bilder aus Liquid geladen:', this.state.liquidProductImages.length);
            } catch (e) {
              console.error('Fehler beim Parsen der Bilder:', e);
              this.state.liquidProductImages = [];
            }
          } else {
            this.state.liquidProductImages = [];
          }
          
          if (this.productCache[productHandle]) {
            console.log('Lade aus Cache...');
            this.applyProductDataFromCache(productHandle);
          } else {
            console.log('Lade von API: /products/' + productHandle + '.js');
            this.loadProductVariants(productHandle).catch(err => console.error('Error:', err));
          }
          this.updateUI();
        });
      });
    });
    
    // Team section
    if (this.elements.teamSection) {
      const logoCheckbox = this.elements.teamSection.querySelector('[data-team-option="logo"]');
      const logoUpload = this.elements.teamSection.querySelector('.teamwear-team-section__logo-upload');
      if (logoCheckbox && logoUpload) {
        logoCheckbox.addEventListener('change', (e) => {
          logoUpload.style.display = e.target.checked ? 'block' : 'none';
          this.calculateDiscountAndPrice();
          this.updateUI();
        });
      }
      
      const teamnameCheckbox = this.elements.teamSection.querySelector('[data-team-option="teamname"]');
      const teamnameInput = this.elements.teamSection.querySelector('.teamwear-team-section__teamname-input');
      if (teamnameCheckbox && teamnameInput) {
        teamnameCheckbox.addEventListener('change', (e) => {
          teamnameInput.style.display = e.target.checked ? 'block' : 'none';
          this.calculateDiscountAndPrice();
          this.updateUI();
        });
      }
      
      if (this.elements.teamLogoInput) {
        this.elements.teamLogoInput.addEventListener('click', (e) => {
          e.preventDefault();
          this.openCloudinaryUpload();
        });
      }
      
      if (this.elements.teamNameInput) {
        this.elements.teamNameInput.addEventListener('input', (e) => {
          this.state.teamName = e.target.value;
        });
      }
    }
    
    // Quantity input
    if (this.elements.quantitySection && this.elements.quantityInput) {
      if (this.elements.teamSection && this.elements.teamSection.style.display !== 'none') {
        this.elements.quantitySection.style.display = 'block';
      }
      
      this.elements.quantityInput.addEventListener('input', (e) => {
        this.state.selectedQuantity = parseInt(e.target.value) || 10;
        this.calculateDiscountAndPrice();
          this.updateUI();
          this.buildPersonalizationList();
        });
      
      this.state.selectedQuantity = parseInt(this.elements.quantityInput.value) || 10;
      this.buildPersonalizationList();
    }
    
    // Personalization checkboxes
    this.section.querySelectorAll('[data-personalization-option]').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
          this.buildPersonalizationList();
        this.calculateDiscountAndPrice();
        this.updateUI();
      });
    });
    
    // Color selection
    if (this.elements.colorsContainer) {
      this.elements.colorsContainer.addEventListener('change', (e) => {
        if (e.target.classList.contains('teamwear-color__input')) {
          const color = this.state.availableColors.find(c => 
            c.name.toLowerCase().trim() === e.target.dataset.colorName.toLowerCase().trim() ||
            c.variantId.toString() === e.target.dataset.variantId
          );
          if (color) {
            this.selectColor(color);
          } else {
            const variant = this.state.productVariants.find(v => v.id.toString() === e.target.dataset.variantId);
            this.selectColor({ name: e.target.dataset.colorName, value: e.target.dataset.colorValue, variantId: e.target.dataset.variantId, variant });
          }
        }
      });
    }
    
    // Submit button
    if (this.elements.submitButton) {
      this.elements.submitButton.addEventListener('click', () => this.handleSubmit());
    }
  }
  
  calculateDiscount(quantity) {
    if (this.state.useDynamicDiscounts && this.state.discountTiers?.length > 0) {
      return this.calculateDynamicDiscount(quantity);
    }
    if (!this.state.discountSettings) return 0;
    const { discountPerTier, tierSize, maxDiscount } = this.state.discountSettings;
    return Math.min(Math.floor(quantity / tierSize) * discountPerTier, maxDiscount);
  }
  
  calculateDynamicDiscount(quantity) {
    let applicableDiscount = 0;
    for (const tier of this.state.discountTiers) {
      if (quantity >= tier.quantity && tier.discount > applicableDiscount) {
        applicableDiscount = tier.discount;
      }
    }
    return Math.min(applicableDiscount, this.state.maxDiscountLimit || 25);
  }
  
  calculateAdditionalPrices() {
    let additionalPricePerPiece = 0;
    
    // Team-Logo Preis pro Stück
    const teamLogoCheckbox = this.section.querySelector('[data-team-option="logo"]');
    if (teamLogoCheckbox && teamLogoCheckbox.checked) {
      const price = parseFloat(teamLogoCheckbox.dataset.price) || 0;
      additionalPricePerPiece += price;
    }
    
    // Teamname Preis pro Stück
    const teamNameCheckbox = this.section.querySelector('[data-team-option="teamname"]');
    if (teamNameCheckbox && teamNameCheckbox.checked) {
      const price = parseFloat(teamNameCheckbox.dataset.price) || 0;
      additionalPricePerPiece += price;
    }
    
    // Personalisierungs-Preise pro Stück
    const numberChestCheckbox = this.section.querySelector('[data-personalization-option="number-chest"]');
    if (numberChestCheckbox && numberChestCheckbox.checked) {
      const price = parseFloat(numberChestCheckbox.dataset.price) || 0;
      additionalPricePerPiece += price;
    }
    
    const numberBackCheckbox = this.section.querySelector('[data-personalization-option="number-back"]');
    if (numberBackCheckbox && numberBackCheckbox.checked) {
      const price = parseFloat(numberBackCheckbox.dataset.price) || 0;
      additionalPricePerPiece += price;
    }
    
    const playerNamesCheckbox = this.section.querySelector('[data-personalization-option="playernames"]');
    if (playerNamesCheckbox && playerNamesCheckbox.checked) {
      const price = parseFloat(playerNamesCheckbox.dataset.price) || 0;
      additionalPricePerPiece += price;
    }
    
    return additionalPricePerPiece;
  }
  
  calculateDiscountAndPrice() {
    if (!this.state.basePrice || !this.state.selectedQuantity) return;
    this.state.selectedDiscount = this.calculateDiscount(this.state.selectedQuantity);
    this.state.finalPrice = this.state.basePrice * (1 - this.state.selectedDiscount / 100);
    
    // Zusätzliche Preise pro Stück hinzufügen
    const additionalPricePerPiece = this.calculateAdditionalPrices();
    this.state.finalPrice += additionalPricePerPiece;
  }
  
  showColorLoading() {
    // Zeige Ladezeichen SOFORT - ohne Verzögerung!
    if (this.elements.colorSelection) this.elements.colorSelection.style.display = 'none';
    if (this.elements.colorsPlaceholder) {
      this.elements.colorsPlaceholder.style.display = 'block';
      this.elements.colorsPlaceholder.classList.add('loading');
      const placeholderText = this.elements.colorsPlaceholder.querySelector('.teamwear-placeholder-text');
      if (placeholderText) placeholderText.textContent = 'Farben werden geladen...';
    }
    if (this.elements.colorsContainer) this.elements.colorsContainer.innerHTML = '';
  }
  
  applyProductDataFromCache(productHandle) {
    const product = this.productCache[productHandle];
    if (!product) return;
    
    this.state.productVariants = product.variants || [];
    this.state.productImages = product.images || [];
    this.state.availableColors = this.extractColorsFromVariants(product.variants, product.images);
    
    // Farben geladen - verstecke Ladezeichen, zeige Farben
    if (this.elements.colorSelection) this.elements.colorSelection.style.display = 'grid';
    if (this.elements.colorsPlaceholder) {
      this.elements.colorsPlaceholder.style.display = 'none';
      this.elements.colorsPlaceholder.classList.remove('loading');
    }
    
    this.renderColorOptions(this.state.availableColors);
    
    if (this.elements.quantitySection) {
      this.elements.quantitySection.style.display = 'block';
      if (this.state.selectedQuantity === 0 && this.elements.quantityInput) {
        this.state.selectedQuantity = parseInt(this.elements.quantityInput.value) || 10;
      }
    }
    
    if (this.elements.teamSection) this.elements.teamSection.style.display = 'block';
    
    // Personalisierung-Sektion anzeigen und initialisieren
    if (this.elements.personalizationContent) {
      this.elements.personalizationContent.style.display = 'block';
      if (this.state.selectedQuantity > 0) {
        this.buildPersonalizationList();
      }
    }
    
    if (this.state.availableColors.length > 0) {
      const firstColor = this.state.availableColors[0];
      this.selectColor(firstColor);
      const firstColorInput = this.elements.colorsContainer.querySelector('.teamwear-color__input');
      if (firstColorInput) firstColorInput.checked = true;
    }
    
    // Nach Design-Auswahl zur Farbauswahl scrollen (nur bei echtem User-Klick)
    if (this.userClickedDesign) {
      this.scrollToColorSection();
      this.userClickedDesign = false;
    }
  }
  
  scrollToColorSection() {
    // Finde die übergeordnete Step-Sektion für Farbe
    const colorStep = this.section.querySelector('[data-step="color"]');
    if (!colorStep) return;
    
    // Kurze Verzögerung für sanfte Animation nach DOM-Update
    setTimeout(() => {
      const headerOffset = 120; // Platz für Header
      const elementPosition = colorStep.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }, 200);
  }
  
  async preloadAllProducts() {
    const productHandles = new Set();
    this.elements.designs.forEach(input => {
      if (input.dataset.productHandle) productHandles.add(input.dataset.productHandle);
    });
    
    Promise.all(Array.from(productHandles).map(async (handle) => {
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (response.ok) this.productCache[handle] = await response.json();
      } catch (error) {
        console.error(`Failed to preload ${handle}:`, error);
      }
    }));
  }
  
  async loadProductVariants(productHandle) {
    console.log('loadProductVariants aufgerufen für:', productHandle);
    if (!productHandle) {
      console.error('FEHLER: Kein productHandle!');
      return;
    }
    if (this.productCache[productHandle]) {
      console.log('Produkt bereits im Cache');
      this.applyProductDataFromCache(productHandle);
      return;
    }
    
    try {
      console.log('Fetching:', `/products/${productHandle}.js`);
      const response = await fetch(`/products/${productHandle}.js`);
      console.log('Response Status:', response.status);
      if (!response.ok) throw new Error(`Failed: ${response.status}`);
      const product = await response.json();
      console.log('Produkt geladen:', product.title);
      console.log('Varianten:', product.variants?.length);
      console.log('Bilder:', product.images?.length);
      this.productCache[productHandle] = product;
      this.applyProductDataFromCache(productHandle);
      this.updateUI();
    } catch (error) {
      console.error('Error loading variants:', error);
      // Zeige Fehler im Placeholder
      if (this.elements.colorsPlaceholder) {
        this.elements.colorsPlaceholder.style.display = 'block';
        const placeholderText = this.elements.colorsPlaceholder.querySelector('.teamwear-placeholder-text');
        if (placeholderText) placeholderText.textContent = 'Fehler beim Laden der Farboptionen';
      }
      this.showMessage('Fehler beim Laden der Farboptionen', 'error');
    }
  }
  
  selectColor(color) {
    this.state.selectedColor = color;
    
    const colorVariants = this.state.productVariants.filter(v => {
      const normalizedColor = color.name.toLowerCase().trim();
      return [v.option1, v.option2, v.option3].some(opt => 
        opt && opt.toLowerCase().trim() === normalizedColor
      );
    });
    
    const variant = colorVariants[0] || color.variant;
    if (!variant) {
      console.error('Keine Variante gefunden für Farbe:', color);
      return;
    }
    
    if (!variant.id) {
      console.error('Variante hat keine ID:', variant);
      return;
    }
    
    this.state.selectedVariantId = variant.id.toString();
    this.state.basePrice = variant.price / 100.0;
    
    console.log('Farbe ausgewählt:', color.name, 'Variant ID:', this.state.selectedVariantId);
    console.log('Produktbilder verfügbar:', this.state.productImages?.length || 0);
    
    // 1. Zuerst das Variantenbild finden (das im Produkt hinterlegte Bild für diese Farbe)
    let variantImage = null;
    for (const v of colorVariants) {
      if (v.featured_image) {
        variantImage = typeof v.featured_image === 'string' ? v.featured_image : (v.featured_image.src || v.featured_image);
        break;
      }
      if (v.image_id && this.state.productImages?.length > 0) {
        const foundImg = this.state.productImages.find(img => {
          const imgObj = typeof img === 'string' ? { id: null } : img;
          return imgObj.id === v.image_id;
        });
        if (foundImg) {
          variantImage = typeof foundImg === 'string' ? foundImg : (foundImg.src || foundImg);
          break;
        }
      }
    }
    
    console.log('Variantenbild gefunden:', variantImage ? 'ja' : 'nein');
    
    // 2. Zusätzliche Bilder mit Farb-Tag im Alt-Text finden
    const taggedImages = this.findAllImagesByColor(color.name);
    console.log('Getaggte Bilder für Farbe:', taggedImages.length);
    
    // 3. Galerie zusammenstellen: Variantenbild zuerst, dann getaggte Bilder (ohne Duplikate)
    const galleryImages = [];
    
    // Variantenbild als erstes hinzufügen
    if (variantImage) {
      galleryImages.push({ src: variantImage, alt: color.name });
    }
    
    // Getaggte Bilder hinzufügen (Duplikate vermeiden)
    taggedImages.forEach(img => {
      const isDuplicate = galleryImages.some(g => g.src === img.src);
      if (!isDuplicate) {
        galleryImages.push(img);
      }
    });
    
    // Fallback: Wenn gar keine Bilder, nimm erstes Produktbild
    if (galleryImages.length === 0 && this.state.productImages?.length > 0) {
      const firstImg = this.state.productImages[0];
      const src = typeof firstImg === 'string' ? firstImg : (firstImg.src || firstImg);
      galleryImages.push({ src, alt: color.name });
    }
    
    console.log('Galerie-Bilder gesamt:', galleryImages.length);
    this.renderColorGallery(galleryImages, color.name);
    
    this.calculateDiscountAndPrice();
    this.updateUI();
  }
  
  findAllImagesByColor(colorName) {
    // Nutze die Bilder aus Liquid (haben Alt-Text) statt aus der API
    const images = this.state.liquidProductImages || this.state.productImages || [];
    if (!images.length) return [];
    
    const normalizedColor = colorName.toLowerCase().trim();
    const matchingImages = [];
    
    console.log('=== BILD-FILTER DEBUG ===');
    console.log('Suche nach Farbe:', normalizedColor);
    console.log('Anzahl Bilder (aus Liquid):', images.length);
    
    for (const image of images) {
      const imageObj = typeof image === 'string' ? { src: image } : image;
      const altText = (imageObj.alt || '').toLowerCase().trim();
      
      console.log('Bild Alt-Text:', altText || '(leer)', '| Src:', imageObj.src?.substring(0, 50));
      
      // Prüfe ob Alt-Text die Farbe enthält - NUR diese Bilder zurückgeben
      if (altText && (altText === normalizedColor || altText.includes(normalizedColor))) {
        console.log('  → MATCH!');
        matchingImages.push({
          src: imageObj.src || image,
          alt: imageObj.alt || colorName
        });
      }
    }
    
    console.log('Gefundene Matches:', matchingImages.length);
    
    // KEIN Fallback - nur getaggte Bilder zurückgeben
    return matchingImages;
  }
  
  renderColorGallery(images, colorName) {
    this.state.currentColorImages = images;
    this.state.currentColorImageIndex = 0;
    
    console.log('renderColorGallery aufgerufen mit', images.length, 'Bildern');
    console.log('colorPreviewImage Element:', this.elements.colorPreviewImage ? 'gefunden' : 'NICHT gefunden');
    
    // Hauptbild setzen
    if (images.length > 0 && this.elements.colorPreviewImage) {
      const imgSrc = images[0].src;
      console.log('Setze Hauptbild:', imgSrc);
      this.elements.colorPreviewImage.src = imgSrc;
      this.elements.colorPreviewImage.alt = images[0].alt || colorName;
      this.elements.colorPreviewImage.style.opacity = '0';
      setTimeout(() => this.elements.colorPreviewImage.style.opacity = '1', 50);
    } else if (this.elements.colorPreviewImage && this.state.productImages?.length > 0) {
      // Fallback: Erstes verfügbares Produktbild anzeigen
      const firstImg = this.state.productImages[0];
      const imgSrc = typeof firstImg === 'string' ? firstImg : (firstImg.src || firstImg);
      console.log('Fallback Bild:', imgSrc);
      this.elements.colorPreviewImage.src = imgSrc;
      this.elements.colorPreviewImage.alt = colorName;
    }
    
    // Navigation-Buttons anzeigen/verstecken
    const hasMultiple = images.length > 1;
    if (this.elements.colorNavPrev) {
      this.elements.colorNavPrev.style.display = hasMultiple ? 'flex' : 'none';
    }
    if (this.elements.colorNavNext) {
      this.elements.colorNavNext.style.display = hasMultiple ? 'flex' : 'none';
    }
    
    // Thumbnails rendern
    if (this.elements.colorThumbnails) {
      this.elements.colorThumbnails.innerHTML = '';
      
      if (images.length > 1) {
        images.forEach((img, index) => {
          const thumb = document.createElement('div');
          thumb.className = `teamwear-color-preview__thumb ${index === 0 ? 'active' : ''}`;
          thumb.innerHTML = `<img src="${img.src}" alt="${img.alt || colorName}" loading="lazy">`;
          thumb.addEventListener('click', () => this.showColorImage(index));
          this.elements.colorThumbnails.appendChild(thumb);
        });
      }
    }
    
    // Navigation Events initialisieren (einmalig)
    this.initColorGalleryNavigation();
  }
  
  initColorGalleryNavigation() {
    if (this._colorGalleryNavInitialized) return;
    this._colorGalleryNavInitialized = true;
    
    if (this.elements.colorNavPrev) {
      this.elements.colorNavPrev.addEventListener('click', () => {
        const newIndex = this.state.currentColorImageIndex - 1;
        if (newIndex >= 0) this.showColorImage(newIndex);
      });
    }
    
    if (this.elements.colorNavNext) {
      this.elements.colorNavNext.addEventListener('click', () => {
        const newIndex = this.state.currentColorImageIndex + 1;
        if (newIndex < this.state.currentColorImages.length) this.showColorImage(newIndex);
      });
    }
    
    // Zoom-Button für Galerie
    if (this.elements.colorZoomBtn) {
      this.elements.colorZoomBtn.addEventListener('click', () => {
        if (this.state.currentColorImages?.length > 0 && window.teamwearLightbox) {
          // Bilder an die globale Lightbox-Instanz übergeben
          window.teamwearLightbox.currentImages = this.state.currentColorImages;
          window.teamwearLightbox.currentIndex = this.state.currentColorImageIndex || 0;
          // Lightbox öffnen
          window.teamwearLightbox.lightbox.classList.add('active');
          document.body.style.overflow = 'hidden';
          window.teamwearLightbox.updateLightboxImage();
        }
      });
    }
  }
  
  showColorImage(index) {
    if (!this.state.currentColorImages || index < 0 || index >= this.state.currentColorImages.length) return;
    
    this.state.currentColorImageIndex = index;
    const image = this.state.currentColorImages[index];
    
    if (this.elements.colorPreviewImage) {
      this.elements.colorPreviewImage.style.opacity = '0';
      setTimeout(() => {
        this.elements.colorPreviewImage.src = image.src;
        this.elements.colorPreviewImage.alt = image.alt;
        this.elements.colorPreviewImage.style.opacity = '1';
      }, 150);
    }
    
    // Aktiven Thumbnail markieren
    if (this.elements.colorThumbnails) {
      const thumbs = this.elements.colorThumbnails.querySelectorAll('.teamwear-color-preview__thumb');
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('active', i === index);
      });
    }
    
    // Nav-Buttons aktualisieren
    if (this.elements.colorNavPrev) {
      this.elements.colorNavPrev.style.opacity = index === 0 ? '0.3' : '1';
      this.elements.colorNavPrev.style.pointerEvents = index === 0 ? 'none' : 'auto';
    }
    if (this.elements.colorNavNext) {
      this.elements.colorNavNext.style.opacity = index === this.state.currentColorImages.length - 1 ? '0.3' : '1';
      this.elements.colorNavNext.style.pointerEvents = index === this.state.currentColorImages.length - 1 ? 'none' : 'auto';
    }
  }
  
  findImageByColor(colorName) {
    if (!this.state.productImages?.length) return null;
    
    const normalizedColor = colorName.toLowerCase().trim();
    for (const image of this.state.productImages) {
      const imageObj = typeof image === 'string' ? { src: image } : image;
      const altText = imageObj.alt || '';
      if (altText && (altText.toLowerCase().trim() === normalizedColor || altText.toLowerCase().includes(normalizedColor))) {
        return { src: imageObj.src || image, alt: altText };
      }
    }
    
    const firstImage = this.state.productImages[0];
    const firstImageObj = typeof firstImage === 'string' ? { src: firstImage } : firstImage;
    return { src: firstImageObj.src || firstImage, alt: firstImageObj.alt || colorName };
  }
  
  extractColorsFromVariants(variants, images) {
    if (!variants?.length) return [];
    
    const colorMap = new Map();
    // Erweiterte Größen-Keywords
    const sizeKeywords = ['xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', '2xl', '3xl', '4xl', '5xl', 'größe', 'size', 'one size', 'einheitsgröße'];
    
    const optionSet1 = new Set();
    const optionSet2 = new Set();
    const optionSet3 = new Set();
    
    variants.forEach(v => {
      if (v.option1) optionSet1.add(v.option1.toLowerCase().trim());
      if (v.option2) optionSet2.add(v.option2.toLowerCase().trim());
      if (v.option3) optionSet3.add(v.option3.toLowerCase().trim());
    });
    
    console.log('Varianten-Optionen:', {
      option1: Array.from(optionSet1),
      option2: Array.from(optionSet2),
      option3: Array.from(optionSet3)
    });
    
    // Prüfe welche Option Farben enthält (nicht nur Größen)
    const isOnlySizes = (optSet) => {
      if (optSet.size === 0) return true;
      return Array.from(optSet).every(v => sizeKeywords.includes(v) || /^[0-9]+$/.test(v));
    };
    
    let colorOptionIndex = 0;
    if (!isOnlySizes(optionSet1)) {
      colorOptionIndex = 1;
    } else if (!isOnlySizes(optionSet2)) {
      colorOptionIndex = 2;
    } else if (!isOnlySizes(optionSet3)) {
      colorOptionIndex = 3;
    }
    
    console.log('Farb-Option Index:', colorOptionIndex);
    
    if (colorOptionIndex > 0) {
      variants.forEach(variant => {
        let colorOption = colorOptionIndex === 1 ? variant.option1 : 
                         (colorOptionIndex === 2 ? variant.option2 : variant.option3);
        
        if (colorOption && !sizeKeywords.includes(colorOption.toLowerCase().trim())) {
          const normalizedColor = colorOption.toLowerCase().trim();
          if (!colorMap.has(normalizedColor)) {
            colorMap.set(normalizedColor, {
              name: colorOption,
              value: this.getColorValue(colorOption),
              variantId: variant.id,
              variant: variant
            });
          }
        }
      });
    }
    
    let colors = Array.from(colorMap.values());
    console.log('Extrahierte Farben:', colors.length, colors.map(c => c.name));
    
    // Fallback: Wenn keine Farben gefunden, aber Varianten existieren
    // Zeige eine "Standard"-Farbe basierend auf der ersten Variante
    if (colors.length === 0 && variants.length > 0) {
      console.log('Keine Farben gefunden - erstelle Standard-Farbe');
      const firstVariant = variants[0];
      colors = [{
        name: 'Standard',
        value: '#000000',
        variantId: firstVariant.id,
        variant: firstVariant
      }];
    }
    
    return colors;
  }
  
  getColorValue(colorName) {
    const colorMap = {
      // Basis-Farben
      'schwarz': '#000000',
      'black': '#000000',
      'weiß': '#ffffff',
      'weiss': '#ffffff',
      'white': '#ffffff',
      
      // Rot-Töne
      'rot': '#ef4444',
      'red': '#ef4444',
      'dunkelrot': '#dc2626',
      'hellrot': '#f87171',
      
      // Blau-Töne
      'blau': '#3b82f6',
      'blue': '#3b82f6',
      'hellblau': '#60a5fa',
      'lightblue': '#60a5fa',
      'dunkelblau': '#1e3a8a',
      'marineblau': '#1e40af',
      'navy': '#1e3a8a',
      
      // Grün-Töne
      'grün': '#22c55e',
      'gruen': '#22c55e',
      'green': '#22c55e',
      'hellgrün': '#4ade80',
      'hellgruen': '#4ade80',
      'dunkelgrün': '#15803d',
      'dunkelgruen': '#15803d',
      'darkgreen': '#15803d',
      
      // Gelb/Orange-Töne
      'gelb': '#facc15',
      'yellow': '#facc15',
      'orange': '#f97316',
      
      // Lila/Pink-Töne
      'lila': '#a855f7',
      'purple': '#a855f7',
      'violett': '#a855f7',
      'pink': '#ec4899',
      'rosa': '#f9a8d4',
      
      // Grau-Töne
      'grau': '#6b7280',
      'grey': '#6b7280',
      'gray': '#6b7280',
      
      // Sonstige
      'türkis': '#14b8a6',
      'turkis': '#14b8a6',
      'tuerkis': '#14b8a6',
      'turquoise': '#14b8a6',
      'braun': '#a16207',
      'brown': '#a16207',
      'maroon': '#7f1d1d',
      'gold': '#d4af37',
      'silber': '#c0c0c0',
      'silver': '#c0c0c0',
      'beige': '#d4c4a8',
      'mehrfarbig': '#e5e7eb'
    };
    
    // Normalisiere den Farbnamen: lowercase, trim, und ersetze ß durch ss
    let normalized = colorName.toLowerCase().trim();
    // Ersetze deutsche Sonderzeichen für bessere Kompatibilität
    normalized = normalized.replace(/ß/g, 'ss').replace(/ü/g, 'ue').replace(/ö/g, 'oe').replace(/ä/g, 'ae');
    
    console.log('=== getColorValue DEBUG ===');
    console.log('Original colorName:', colorName);
    console.log('Normalized (after ß→ss):', normalized);
    console.log('Contains hyphen:', normalized.includes('-'));
    
    // Prüfe ob es eine einzelne Farbe ist
    if (colorMap[normalized]) {
      console.log('Einzelfarbe gefunden:', colorMap[normalized]);
      return colorMap[normalized];
    }
    
    // Prüfe ob es eine zweifarbige Variante ist (z.B. "gelb-weiß")
    if (normalized.includes('-')) {
      const parts = normalized.split('-');
      console.log('Zwei Teile nach Split:', parts);
      if (parts.length === 2) {
        // Parts nochmal normalisieren (Sonderzeichen ersetzen)
        let part1 = parts[0].trim().replace(/ß/g, 'ss').replace(/ü/g, 'ue').replace(/ö/g, 'oe').replace(/ä/g, 'ae');
        let part2 = parts[1].trim().replace(/ß/g, 'ss').replace(/ü/g, 'ue').replace(/ö/g, 'oe').replace(/ä/g, 'ae');
        console.log('Part 1 (normalized):', part1, '| Part 2 (normalized):', part2);
        
        const color1 = colorMap[part1];
        const color2 = colorMap[part2];
        console.log('Color 1 lookup:', color1);
        console.log('Color 2 lookup:', color2);
        
        if (color1 && color2) {
          console.log('✅ Zweifarbig erkannt! Gradient wird erstellt.');
          // Gibt ein spezielles Objekt zurück für zweifarbige Swatches
          return { isGradient: true, color1, color2 };
        } else {
          console.log('❌ Farbe(n) nicht im colorMap gefunden!');
          console.log('Verfügbare Farben:', Object.keys(colorMap).join(', '));
        }
      }
    }
    
    console.log('Fallback: grau');
    return '#f3f4f6';
  }
  
  renderColorOptions(colors) {
    if (!this.elements.colorsContainer) return;
    
    this.elements.colorsContainer.innerHTML = '';
    
    if (colors.length === 0) {
      if (this.elements.colorsPlaceholder) {
        this.elements.colorsPlaceholder.style.display = 'block';
        this.elements.colorsContainer.style.display = 'none';
      }
      return;
    }
    
    if (this.elements.colorsPlaceholder) this.elements.colorsPlaceholder.style.display = 'none';
    this.elements.colorsContainer.style.display = 'flex';
    
    colors.forEach((color, index) => {
      const colorId = `color-${color.variantId}-${index}`;
      const colorElement = document.createElement('div');
      colorElement.className = 'teamwear-color';
      
      // Prüfe ob es eine zweifarbige Variante ist
      let swatchStyle = '';
      let swatchClass = 'teamwear-color__swatch';
      
      if (typeof color.value === 'object' && color.value.isGradient) {
        // Zweifarbiger Gradient - diagonale Teilung
        swatchStyle = `background: linear-gradient(135deg, ${color.value.color1} 0%, ${color.value.color1} 50%, ${color.value.color2} 50%, ${color.value.color2} 100%); border: 1px solid rgba(0,0,0,0.1);`;
        swatchClass += ' teamwear-color__swatch--gradient';
      } else {
        // Einzelne Farbe
        const colorValue = typeof color.value === 'string' ? color.value : '#f3f4f6';
        swatchStyle = `--color-value: ${colorValue}; background-color: ${colorValue};`;
        // Füge Border für helle Farben hinzu
        if (colorValue.toLowerCase() === '#ffffff' || colorValue.toLowerCase() === '#f3f4f6') {
          swatchStyle += ' border: 1px solid rgba(0,0,0,0.1);';
        }
      }
      
      colorElement.innerHTML = `
        <input type="radio" name="teamwear-color" id="${colorId}" class="teamwear-color__input"
               data-variant-id="${color.variantId}" data-color-name="${color.name}" data-color-value="${typeof color.value === 'string' ? color.value : 'gradient'}"
               ${index === 0 ? 'checked' : ''}>
        <label for="${colorId}" class="teamwear-color__label">
          <div class="${swatchClass}" style="${swatchStyle}"></div>
          <span class="teamwear-color__name">${color.name}</span>
        </label>
      `;
      this.elements.colorsContainer.appendChild(colorElement);
    });
  }
  
  buildPersonalizationList() {
    if (!this.elements.personalizationList) return;
    
    // Hole aktuelle Menge
    const count = Math.max(this.state.selectedQuantity || 0, 1);
    const availableSizes = this.getAvailableSizes();
    
    // Leere Tabelle
    this.elements.personalizationList.innerHTML = '';
    this.state.personalization = [];
    
    // Erstelle Zeilen
    for (let i = 1; i <= count; i++) {
      const tr = document.createElement('tr');
      tr.innerHTML = `
        <td>${i}</td>
        <td data-cell-name><input type="text" placeholder="Name" data-index="${i - 1}" data-type="name"></td>
        <td data-cell-number><input type="text" placeholder="Nr." data-index="${i - 1}" data-type="number"></td>
        <td><select data-index="${i - 1}" data-type="size">${availableSizes.map(s => `<option value="${s}">${s}</option>`).join('')}</select></td>
      `;
      this.elements.personalizationList.appendChild(tr);
      this.state.personalization.push({ name: '', number: '', size: '' });
    }
    
    // Spalten-Sichtbarkeit basierend auf Checkboxen
    const showName = !!this.section.querySelector('[data-personalization-option="playernames"]')?.checked;
    const showNumber = !!this.section.querySelector('[data-personalization-option="number-chest"]')?.checked || 
                      !!this.section.querySelector('[data-personalization-option="number-back"]')?.checked;
    
    const nameCol = this.section.querySelector('[data-col-name]');
    const numberCol = this.section.querySelector('[data-col-number]');
    
    if (nameCol) nameCol.style.display = showName ? '' : 'none';
    if (numberCol) numberCol.style.display = showNumber ? '' : 'none';
    
    this.elements.personalizationList.querySelectorAll('[data-cell-name]').forEach(td => {
      td.style.display = showName ? '' : 'none';
    });
    
    this.elements.personalizationList.querySelectorAll('[data-cell-number]').forEach(td => {
      td.style.display = showNumber ? '' : 'none';
    });
    
    // Event-Listener für Inputs
    this.elements.personalizationList.querySelectorAll('input, select').forEach(input => {
      input.addEventListener('change', (e) => {
        const index = parseInt(e.target.dataset.index);
        const type = e.target.dataset.type;
        if (this.state.personalization[index]) {
        this.state.personalization[index][type] = e.target.value;
        }
      });
      
      input.addEventListener('input', (e) => {
        const index = parseInt(e.target.dataset.index);
        const type = e.target.dataset.type;
        if (this.state.personalization[index]) {
        this.state.personalization[index][type] = e.target.value;
        }
      });
    });
  }
  
  getAvailableSizes() {
    const sizes = new Set();
    const sizeKeywords = ['xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'];
    
    if (this.state.productVariants?.length > 0) {
      this.state.productVariants.forEach(variant => {
        [variant.option1, variant.option2, variant.option3].forEach(option => {
          if (option) {
            const normalized = option.toLowerCase().trim();
            if (sizeKeywords.includes(normalized) || /^\d+$/.test(normalized)) {
              sizes.add(option);
            }
          }
        });
      });
    }
    
    if (sizes.size === 0) return ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
    
    const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    return Array.from(sizes).sort((a, b) => {
      const aIndex = sizeOrder.indexOf(a.toUpperCase());
      const bIndex = sizeOrder.indexOf(b.toUpperCase());
      if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      return a.localeCompare(b);
    });
  }
  
  updateUI() {
    const isValid = this.validateForm();
    
    if (this.state.selectedQuantity > 0 && this.state.finalPrice > 0) {
      // finalPrice ist bereits der Preis pro Stück (inklusive Zusatzoptionen)
      const totalPrice = this.state.finalPrice * this.state.selectedQuantity * 100;
      
      if (this.elements.totalPrice) {
        this.elements.totalPrice.textContent = this.formatMoney(totalPrice);
      }
      if (this.elements.priceDetails) {
        const basePriceWithoutAddons = this.state.basePrice * (1 - this.state.selectedDiscount / 100);
        const additionalPricePerPiece = this.calculateAdditionalPrices();
        let detailsText = `(${this.state.selectedQuantity} × ${this.formatMoney(basePriceWithoutAddons * 100)}`;
        if (this.state.selectedDiscount > 0) {
          detailsText += ` mit ${this.state.selectedDiscount}% Rabatt`;
        }
        if (additionalPricePerPiece > 0) {
          detailsText += ` + ${this.formatMoney(additionalPricePerPiece * 100)} Zusatzoptionen pro Stück`;
        }
        detailsText += ')';
        this.elements.priceDetails.textContent = detailsText;
      }
    }
    
    if (this.elements.submitButton) {
      this.elements.submitButton.disabled = !isValid;
    }
    
    // Personalisierungs-Tabelle aktualisieren
    if (this.elements.personalizationList && this.state.selectedQuantity > 0) {
      this.buildPersonalizationList();
    }
  }
  
  validateForm() {
    const hasProduct = this.state.selectedProduct !== null;
    const hasColor = this.state.selectedColor !== null && this.state.selectedVariantId !== null;
    const hasQuantity = this.state.selectedQuantity > 0;
    return hasProduct && hasColor && hasQuantity;
  }
  
  formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, this.config.moneyFormat);
    }
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `${amount} €`;
  }
  
  async handleSubmit() {
    if (!this.state.selectedProduct) {
      this.showMessage(this.config.translations.selectDesign || 'Bitte wähle ein Design aus', 'error');
      return;
    }
    
    if (!this.state.selectedVariantId) {
      this.showMessage(this.config.translations.selectColor || 'Bitte wähle eine Farbe aus', 'error');
      return;
    }
    
    if (!this.state.selectedQuantity || this.state.selectedQuantity <= 0) {
      this.showMessage(this.config.translations.correctSizes || 'Bitte gib mindestens eine Größe an', 'error');
      return;
    }
    
    if (!this.validateForm()) {
      this.showMessage(this.config.translations.correctSizes || 'Bitte korrigiere die Größenangaben', 'error');
      return;
    }
    
    this.elements.submitButton.disabled = true;
    this.elements.submitButton.classList.add('loading');
    this.elements.submitButton.textContent = this.config.translations.addingToCart || 'Wird hinzugefügt...';
    
    try {
      // Sammle Personalisierungsdaten
      const personalProps = this.formatPersonalizationProperties();
      
      let properties = {
        '_teamwear_set': 'true',
        'Design': this.state.selectedProduct.name || 'Unbekanntes Design',
        'Farbe': this.state.selectedColor ? this.state.selectedColor.name : 'Nicht ausgewählt',
        'Menge': this.state.selectedQuantity.toString(),
        'Basispreis pro Stück': this.formatMoney(this.state.basePrice * 100),
        'Rabatt': this.state.selectedDiscount > 0 ? `${this.state.selectedDiscount}%` : 'Kein Rabatt',
        'Preis pro Stück (nach Rabatt)': this.formatMoney((this.state.basePrice * (1 - this.state.selectedDiscount / 100)) * 100),
        ...personalProps
      };
      
      // Zusätzliche Preise hinzufügen (nur wenn aktiviert)
      const additionalPricePerPiece = this.calculateAdditionalPrices();
      if (additionalPricePerPiece > 0) {
        properties['Zusatzoptionen pro Stück'] = this.formatMoney(additionalPricePerPiece * 100);
        properties['Zusatzoptionen gesamt'] = this.formatMoney(additionalPricePerPiece * this.state.selectedQuantity * 100);
        
        // Einzelne aktivierte Optionen mit Preisen auflisten
        const teamLogoCheckbox = this.section.querySelector('[data-team-option="logo"]');
        if (teamLogoCheckbox && teamLogoCheckbox.checked) {
          const price = parseFloat(teamLogoCheckbox.dataset.price) || 0;
          if (price > 0) {
            properties['Logo hinzufügen Preis'] = `${this.formatMoney(price * 100)} pro Stück`;
          }
        }
        
        const teamNameCheckbox = this.section.querySelector('[data-team-option="teamname"]');
        if (teamNameCheckbox && teamNameCheckbox.checked) {
          const price = parseFloat(teamNameCheckbox.dataset.price) || 0;
          if (price > 0) {
            properties['Teamname Preis'] = `${this.formatMoney(price * 100)} pro Stück`;
          }
        }
        
        const numberChestCheckbox = this.section.querySelector('[data-personalization-option="number-chest"]');
        if (numberChestCheckbox && numberChestCheckbox.checked) {
          const price = parseFloat(numberChestCheckbox.dataset.price) || 0;
          if (price > 0) {
            properties['Nummer Brust Preis'] = `${this.formatMoney(price * 100)} pro Stück`;
          }
        }
        
        const numberBackCheckbox = this.section.querySelector('[data-personalization-option="number-back"]');
        if (numberBackCheckbox && numberBackCheckbox.checked) {
          const price = parseFloat(numberBackCheckbox.dataset.price) || 0;
          if (price > 0) {
            properties['Nummer Rücken Preis'] = `${this.formatMoney(price * 100)} pro Stück`;
          }
        }
        
        const playerNamesCheckbox = this.section.querySelector('[data-personalization-option="playernames"]');
        if (playerNamesCheckbox && playerNamesCheckbox.checked) {
          const price = parseFloat(playerNamesCheckbox.dataset.price) || 0;
          if (price > 0) {
            properties['Spielernamen Preis'] = `${this.formatMoney(price * 100)} pro Stück`;
          }
        }
      }
      
      properties['Gesamtpreis pro Stück'] = this.formatMoney(this.state.finalPrice * 100);
      properties['Gesamtpreis'] = this.formatMoney(this.state.finalPrice * this.state.selectedQuantity * 100);
      
      // Varianten-ID validieren
      const variantId = parseInt(this.state.selectedVariantId);
      if (!variantId || isNaN(variantId)) {
        throw new Error(`Ungültige Varianten-ID: ${this.state.selectedVariantId}`);
      }
      
      // Menge validieren
      const quantity = parseInt(this.state.selectedQuantity);
      if (!quantity || quantity <= 0 || isNaN(quantity)) {
        throw new Error(`Ungültige Menge: ${this.state.selectedQuantity}`);
      }
      
      // Properties validieren (Shopify Limits: max 100 Properties, max 100 Zeichen pro Property-Wert)
      const propertyKeys = Object.keys(properties);
      if (propertyKeys.length > 100) {
        console.warn('Zu viele Properties:', propertyKeys.length);
        // Reduziere auf die wichtigsten Properties
        const typeLabels = ['Trikot', 'Trikotset', 'Shooting Shirt', 'Hoodie', 'Sweater', 'Longsleeve', 'T-Shirt', 'Polo', 'Shorts', 'Hose'];
        const importantKeys = ['_teamwear_set', 'Design', 'Farbe', 'Menge', 'Team Logo', 'Teamname', ...propertyKeys.filter(k => typeLabels.some(label => k.startsWith(label + ' ')))];
        const limitedProperties = {};
        importantKeys.forEach(key => {
          if (properties[key]) {
            const value = String(properties[key]);
            limitedProperties[key] = value.length > 100 ? value.substring(0, 97) + '...' : value;
          }
        });
        properties = limitedProperties;
      }
      
      // Validiere Property-Werte Länge
      Object.keys(properties).forEach(key => {
        const value = String(properties[key]);
        if (value.length > 100) {
          console.warn(`Property "${key}" ist zu lang (${value.length} Zeichen), wird gekürzt`);
          properties[key] = value.substring(0, 97) + '...';
        }
      });
      
      // Debug: Logge alle wichtigen Daten vor dem Request
      console.log('=== Warenkorb Request Debug ===');
      console.log('Variant ID:', variantId);
      console.log('Variant ID Type:', typeof variantId);
      console.log('Menge:', quantity);
      console.log('Menge Type:', typeof quantity);
      console.log('Properties:', properties);
      console.log('Properties Count:', Object.keys(properties).length);
      console.log('Properties Size (approx):', JSON.stringify(properties).length, 'bytes');
      
      const requestBody = { id: variantId, quantity: quantity, properties };
      console.log('Request Body:', requestBody);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(requestBody)
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Shopify Error Response:', errorText);
        console.error('Response Status:', response.status);
        console.error('Request Body that failed:', requestBody);
        
        // Versuche, die Fehlermeldung zu parsen
        let errorMessage = 'Ungültige Produktkonfiguration.';
        try {
          const errorData = JSON.parse(errorText);
          if (errorData.message) {
            errorMessage = errorData.message;
            // Übersetze häufige Shopify-Fehlermeldungen
            if (errorData.message.includes('sold out') || errorData.message.includes('already sold out')) {
              errorMessage = 'Dieses Produkt ist leider ausverkauft. Bitte wähle eine andere Farbe oder Variante.';
            } else if (errorData.message.includes('not available')) {
              errorMessage = 'Dieses Produkt ist derzeit nicht verfügbar.';
            } else if (errorData.message.includes('quantity')) {
              errorMessage = 'Die gewünschte Menge ist nicht verfügbar.';
            }
          } else if (errorData.description) {
            errorMessage = errorData.description;
          }
        } catch (e) {
          // Wenn Parsing fehlschlägt, verwende Standard-Fehlermeldung
          if (response.status === 422) {
            errorMessage = 'Ungültige Produktkonfiguration. Bitte überprüfe deine Auswahl.';
          } else if (response.status === 404) {
            errorMessage = 'Produkt nicht gefunden.';
          }
        }
        
        throw new Error(`Failed: ${response.status} - ${errorMessage}`);
      }
      
      const cartData = await response.json();
      
      // Hole Cart-Sections für Drawer Update
      const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
      const sectionsResponse = await fetch(`${window.Shopify.routes.root}?sections=${sectionsToRender.join(',')}`);
      const sectionsData = await sectionsResponse.json();
      
      // Dispatche korrektes CartAddEvent (richtiger Event-Name!)
      const cartAddEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartData,
          sourceId: this.state.selectedVariantId.toString(),
          data: {
            source: 'teamwear-calculator',
            itemCount: this.state.selectedQuantity,
            productId: this.state.selectedProduct?.id.toString(),
            sections: sectionsData
          }
        }
      });
      document.dispatchEvent(cartAddEvent);
      
      this.showMessage(this.config.translations.addedToCart || 'Erfolgreich hinzugefügt!', 'success');
      this.updateCartCount();
      
      // Öffne Cart Drawer nach Update
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        setTimeout(() => cartDrawer.open(), 500);
      }
      
      setTimeout(() => this.resetForm(), 2000);
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      let errorMessage = this.config.translations.error || 'Es ist ein Fehler aufgetreten.';
      
      // Extrahiere die benutzerfreundliche Fehlermeldung aus dem Error-Objekt
      if (error.message && error.message.includes('Failed: 422')) {
        // Die Fehlermeldung wurde bereits in der Response-Behandlung formatiert
        const messageMatch = error.message.match(/Failed: \d+ - (.+)/);
        if (messageMatch && messageMatch[1]) {
          errorMessage = messageMatch[1];
        } else {
          errorMessage = 'Ungültige Produktkonfiguration. Bitte überprüfe deine Auswahl.';
        }
      } else if (error.message && error.message.includes('404')) {
        errorMessage = 'Produkt nicht gefunden.';
      } else if (error.message && error.message.includes('Failed to fetch')) {
        errorMessage = 'Netzwerkfehler. Bitte versuche es erneut.';
      } else if (error.message && error.message.includes('Ungültige Varianten-ID')) {
        errorMessage = 'Bitte wähle eine Farbe aus.';
      } else if (error.message && error.message.includes('Ungültige Menge')) {
        errorMessage = 'Bitte gib eine gültige Menge ein.';
      }
      
      this.showMessage(errorMessage, 'error');
    } finally {
      this.elements.submitButton.disabled = false;
      this.elements.submitButton.classList.remove('loading');
      this.elements.submitButton.textContent = this.elements.submitButton.getAttribute('data-original-text') || 'In den Warenkorb';
    }
  }
  
  collectPersonalizationData() {
    // Sammle Daten direkt aus den Input-Feldern, um sicherzustellen, dass alle aktuellen Werte erfasst werden
    const personalData = [];
    
    if (this.elements.personalizationList) {
      const rows = this.elements.personalizationList.querySelectorAll('tr');
      rows.forEach((row, index) => {
        const nameInput = row.querySelector('[data-type="name"]');
        const numberInput = row.querySelector('[data-type="number"]');
        const sizeSelect = row.querySelector('[data-type="size"]');
        
        const item = {
          name: nameInput ? nameInput.value.trim() : '',
          number: numberInput ? numberInput.value.trim() : '',
          size: sizeSelect ? sizeSelect.value.trim() : ''
        };
        
        personalData.push(item);
      });
    }
    
    return personalData;
  }
  
  getProductTypeInfo(type) {
    // article: für DEIN/DEINE X (singular), articlePl: für DEINE X (plural)
    // showBack/showChest/showNames: welche Personalisierungs-Checkboxen angezeigt werden
    const typeMap = {
      'Trikot':         { singular: 'Trikot',         plural: 'Trikots',         article: 'dein',  articlePl: 'deine', numberLabel: 'Rückennummern', showBack: true,  showChest: true,  showNames: true  },
      'Trikotset':      { singular: 'Trikotset',      plural: 'Trikotsets',      article: 'dein',  articlePl: 'deine', numberLabel: 'Rückennummern', showBack: true,  showChest: true,  showNames: true  },
      'Shooting Shirt': { singular: 'Shooting Shirt', plural: 'Shooting Shirts', article: 'dein',  articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: true  },
      'Hoodie':         { singular: 'Hoodie',         plural: 'Hoodies',         article: 'deinen',articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: true  },
      'Hoodie Set':     { singular: 'Hoodie Set',     plural: 'Hoodie Sets',     article: 'dein',  articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: true  },
      'Sweater':        { singular: 'Sweater',        plural: 'Sweater',         article: 'deinen',articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: true  },
      'Longsleeve':     { singular: 'Longsleeve',     plural: 'Longsleeves',     article: 'dein',  articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: true  },
      'Longsleeve Set': { singular: 'Longsleeve Set', plural: 'Longsleeve Sets', article: 'dein',  articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: true  },
      'T-Shirt':        { singular: 'T-Shirt',        plural: 'T-Shirts',        article: 'dein',  articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: true  },
      'T-Shirt Set':    { singular: 'T-Shirt Set',    plural: 'T-Shirt Sets',    article: 'dein',  articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: true  },
      'Polo':           { singular: 'Polo',           plural: 'Polos',           article: 'dein',  articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: true  },
      'Shorts':         { singular: 'Shorts',         plural: 'Shorts',          article: 'deine', articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: true,  showNames: false },
      'Hose':           { singular: 'Hose',           plural: 'Hosen',           article: 'deine', articlePl: 'deine', numberLabel: 'Nummern',       showBack: false, showChest: false, showNames: true  },
    };
    return typeMap[type] || typeMap['Trikot'];
  }

  updateProductTypeTexts() {
    const type = this.state.selectedProductType || 'Trikot';
    const info = this.getProductTypeInfo(type);

    // Color-Beschreibung
    const colorDesc = this.section.querySelector('[data-text-for="color"]')
      || this.section.querySelector('[data-step="color"] .teamwear-step__description');
    if (colorDesc) {
      colorDesc.textContent = `Wähle die gewünschte Farbe für ${info.article} ${info.singular} aus`;
    }

    // Personalisierungs-Beschreibung
    const persDesc = this.section.querySelector('[data-text-for="personalization"]')
      || this.section.querySelector('[data-step="personalization"] .teamwear-step__description');
    if (persDesc) {
      persDesc.textContent = `Füge Namen und ${info.numberLabel} zu ${info.articlePl} ${info.plural} hinzu`;
    }

    // Sizes-Beschreibung (falls vorhanden)
    const sizesDesc = this.section.querySelector('[data-step="sizes"] .teamwear-step__description');
    if (sizesDesc) {
      sizesDesc.textContent = `Gib an, wie viele ${info.plural} du pro Größe benötigst.`;
    }

    // Personalisierungs-Checkboxen ein-/ausblenden je nach Produkttyp
    const toggleOption = (optionName, show) => {
      const input = this.section.querySelector(`[data-personalization-option="${optionName}"]`);
      if (input) {
        const label = input.closest('label');
        if (label) label.style.display = show ? '' : 'none';
        // Wenn ausgeblendet → automatisch deaktivieren damit kein Wert mitgesendet wird
        if (!show && input.checked) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    };

    toggleOption('number-chest', info.showChest);
    toggleOption('number-back',  info.showBack);
    toggleOption('playernames',  info.showNames);
  }

  formatPersonalizationProperties() {
    const personalProps = {};
    
    // Team-Optionen nur hinzufügen, wenn Checkboxen aktiviert sind
    const teamLogoCheckbox = this.section.querySelector('[data-team-option="logo"]');
    if (teamLogoCheckbox && teamLogoCheckbox.checked && this.state.teamLogo) {
      // Speichere Logo-URL statt nur Dateiname
      if (this.state.teamLogo.url) {
        personalProps['Team Logo'] = this.state.teamLogo.url;
        personalProps['Team Logo Name'] = this.state.teamLogo.name || 'Logo';
      } else {
        personalProps['Team Logo'] = this.state.teamLogo.name || 'Logo hochgeladen';
      }
    }
    
    const teamNameCheckbox = this.section.querySelector('[data-team-option="teamname"]');
    if (teamNameCheckbox && teamNameCheckbox.checked && this.state.teamName?.trim()) {
      personalProps['Teamname'] = this.state.teamName.trim();
    }
    
    // Personalisierungsdaten direkt aus den Input-Feldern sammeln
    const personalData = this.collectPersonalizationData();
    
    // Prüfe, ob überhaupt Personalisierungsdaten vorhanden sind
    const hasPersonalizationData = personalData.some(item => 
      item.name || item.number || item.size
    );
    
    if (hasPersonalizationData) {
      personalData.forEach((item, index) => {
        const num = index + 1;
        const itemProps = [];
        
        if (item.name) {
          itemProps.push(`Name: ${item.name}`);
        }
        if (item.number) {
          itemProps.push(`Nummer: ${item.number}`);
        }
        if (item.size) {
          itemProps.push(`Größe: ${item.size}`);
        }
        
        // Nur hinzufügen, wenn mindestens ein Wert vorhanden ist
        if (itemProps.length > 0) {
          const typeLabel = this.getProductTypeInfo(this.state.selectedProductType || 'Trikot').singular;
          personalProps[`${typeLabel} ${num}`] = itemProps.join(', ');
        }
      });
    }
    
    return personalProps;
  }
  
  openCloudinaryUpload() {
    // Cloudinary Upload Widget konfigurieren
    if (typeof cloudinary === 'undefined') {
      this.showMessage('Upload-Service nicht verfügbar. Bitte Seite neu laden.', 'error');
      return;
    }
    
    const widget = cloudinary.createUploadWidget({
      cloudName: 'dr2vjuzvh',
      uploadPreset: 'teamwear-logos',
      folder: 'teamwear-logos',
      clientAllowedFormats: ['png', 'jpg', 'jpeg', 'svg', 'pdf', 'ai'],
      maxFileSize: 10485760, // 10MB
      maxFiles: 1,
      multiple: false,
      sources: ['local'],
      language: 'de',
      text: {
        de: {
          or: 'oder',
          back: 'Zurück',
          advanced: 'Erweitert',
          close: 'Schließen',
          no_results: 'Keine Ergebnisse',
          search_placeholder: 'Dateien durchsuchen',
          about_uw: 'Über den Upload Widget',
          menu: {
            files: 'Meine Dateien',
            web: 'Web-Adresse',
            camera: 'Kamera'
          },
          local: {
            browse: 'Durchsuchen',
            dd_title_single: 'Datei hier ablegen',
            dd_title_multi: 'Dateien hier ablegen',
            drop_title_single: 'Datei ablegen zum Hochladen',
            drop_title_multi: 'Dateien ablegen zum Hochladen'
          },
          actions: {
            upload: 'Hochladen',
            clear_all: 'Alle löschen',
            log_out: 'Abmelden'
          },
          queue: {
            title: 'Upload-Warteschlange',
            title_uploading_with_counter: 'Lade {{num}} Dateien hoch',
            title_processing_with_counter: 'Verarbeite {{num}} Dateien',
            mini_title: 'Hochgeladen',
            mini_title_uploading: 'Wird hochgeladen',
            mini_title_processing: 'Wird verarbeitet',
            show_completed: 'Abgeschlossene anzeigen',
            retry_failed: 'Fehlgeschlagene wiederholen',
            abort_all: 'Alle abbrechen',
            upload_more: 'Weitere hochladen',
            done: 'Fertig',
            mini_upload_count: '{{num}} hochgeladen',
            mini_failed: '{{num}} fehlgeschlagen',
            statuses: {
              uploading: 'Wird hochgeladen...',
              processing: 'Wird verarbeitet...',
              timeout: 'Zeitüberschreitung',
              error: 'Fehler',
              uploaded: 'Fertig',
              aborted: 'Abgebrochen'
            }
          }
        }
      }
    }, (error, result) => {
      if (error) {
        console.error('Cloudinary Upload Error:', error);
        this.showMessage('Fehler beim Hochladen. Bitte versuche es erneut.', 'error');
        return;
      }
      
      if (result.event === 'success') {
        const logoUrl = result.info.secure_url;
        const fileName = result.info.original_filename + '.' + result.info.format;
        
        // Speichere Logo-URL und Dateiname
        this.state.teamLogo = {
          url: logoUrl,
          name: fileName,
          publicId: result.info.public_id
        };
        
        // Zeige Dateinamen im UI
        const fileNameElement = this.elements.teamSection.querySelector('.teamwear-team-section__file-name');
        if (fileNameElement) {
          fileNameElement.textContent = fileName;
        }
        
        this.showMessage('Logo erfolgreich hochgeladen!', 'success');
        console.log('Logo hochgeladen:', logoUrl);
      }
    });
    
    widget.open();
  }
  
  updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update Cart Count in allen Cart-Icon Elementen
        document.querySelectorAll('.cart-count, .cart-icon__count, [data-cart-count]').forEach(element => {
          element.textContent = cart.item_count;
        });
        
        // Update Cart Drawer, falls vorhanden
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.renderCart === 'function') {
          cartDrawer.renderCart(cart);
        }
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }
  
  showMessage(text, type = 'info') {
    if (!this.elements.messages) return;
    this.elements.messages.textContent = text;
    this.elements.messages.className = `teamwear-messages show ${type}`;
    setTimeout(() => this.elements.messages.classList.remove('show'), 5000);
  }
  
  initDesignImageSliders() {
    this.section.querySelectorAll('.teamwear-design__image-wrapper').forEach(wrapper => {
      const slider = wrapper.querySelector('.teamwear-design__image-slider');
      if (!slider) return;
      
      const images = slider.querySelectorAll('.teamwear-design__image');
      if (images.length <= 1) return;
      
      const prevBtn = slider.querySelector('.teamwear-design__slider-btn--prev');
      const nextBtn = slider.querySelector('.teamwear-design__slider-btn--next');
      let currentIndex = 0;
      
      const showImage = (index) => {
        images.forEach((img, i) => {
          img.classList.toggle('visually-hidden', i !== index);
        });
        if (prevBtn) prevBtn.style.display = index === 0 ? 'none' : 'flex';
        if (nextBtn) nextBtn.style.display = index === images.length - 1 ? 'none' : 'flex';
      };
      
      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          currentIndex = Math.max(0, currentIndex - 1);
          showImage(currentIndex);
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          currentIndex = Math.min(images.length - 1, currentIndex + 1);
          showImage(currentIndex);
        });
      }
      
      showImage(0);
    });
  }
  
  resetForm() {
    this.state = {
      selectedProduct: null,
      selectedVariantId: null,
      selectedColor: null,
      selectedQuantity: 0,
      selectedDiscount: 0,
      basePrice: 0,
      finalPrice: 0,
      discountSettings: null,
      productVariants: [],
      productImages: [],
      availableColors: [],
      personalization: [],
      teamLogo: null,
      teamName: ''
    };
    
    if (this.elements.designs) {
      this.elements.designs.forEach(input => input.checked = false);
    }
    
    if (this.elements.colorSelection) this.elements.colorSelection.style.display = 'none';
    if (this.elements.colorsPlaceholder) this.elements.colorsPlaceholder.style.display = 'block';
    if (this.elements.colorsContainer) this.elements.colorsContainer.innerHTML = '';
    if (this.elements.colorPreviewImage) {
      this.elements.colorPreviewImage.src = '';
      this.elements.colorPreviewImage.alt = '';
    }
    
     this.updateUI();
  }
}

/**
 * IMAGE LIGHTBOX / ZOOM FUNCTIONALITY
 */
class TeamwearLightbox {
  constructor() {
    this.currentImages = [];
    this.currentIndex = 0;
    this.lightbox = null;
    this.init();
  }

  init() {
    this.createLightboxModal();
    
    document.addEventListener('click', (e) => {
      const zoomBtn = e.target.closest('[data-zoom-trigger]');
      if (zoomBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.openLightbox(zoomBtn);
      }
    });
  }

  createLightboxModal() {
    if (document.querySelector('.teamwear-lightbox')) return;

    const modal = document.createElement('div');
    modal.className = 'teamwear-lightbox';
    modal.innerHTML = `
      <div class="teamwear-lightbox__container">
        <button class="teamwear-lightbox__close" aria-label="Schließen">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <button class="teamwear-lightbox__nav-btn teamwear-lightbox__nav-btn--prev" aria-label="Vorheriges Bild">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
        <div class="teamwear-lightbox__image-wrapper">
          <img class="teamwear-lightbox__image" src="" alt="Product Image">
        </div>
        <button class="teamwear-lightbox__nav-btn teamwear-lightbox__nav-btn--next" aria-label="Nächstes Bild">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>
        <div class="teamwear-lightbox__counter">
          <span class="teamwear-lightbox__current">1</span> / <span class="teamwear-lightbox__total">1</span>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    this.lightbox = modal;

    modal.querySelector('.teamwear-lightbox__close').addEventListener('click', () => this.closeLightbox());
    modal.querySelector('.teamwear-lightbox__nav-btn--prev').addEventListener('click', () => this.navigate(-1));
    modal.querySelector('.teamwear-lightbox__nav-btn--next').addEventListener('click', () => this.navigate(1));
    modal.addEventListener('click', (e) => {
      if (e.target === modal) this.closeLightbox();
    });

    document.addEventListener('keydown', (e) => {
      if (!this.lightbox.classList.contains('active')) return;
      if (e.key === 'Escape') this.closeLightbox();
      if (e.key === 'ArrowLeft') this.navigate(-1);
      if (e.key === 'ArrowRight') this.navigate(1);
    });
  }

  openLightbox(button) {
    // Unterstützt sowohl Teamwear Calculator als auch Fanshop
    const wrapper = button.closest('.teamwear-design__image-wrapper') || button.closest('.tf-image-slider') || button.closest('.tf-card__media');
    if (!wrapper) return;

    // Finde Bilder (verschiedene Klassen) - suche tiefer in Kindernodes
    let images = Array.from(wrapper.querySelectorAll('.teamwear-design__image, .tf-image'));
    
    // Falls keine gefunden, suche im Parent
    if (images.length === 0) {
      const parent = wrapper.closest('.tf-card__media');
      if (parent) {
        images = Array.from(parent.querySelectorAll('.tf-image'));
      }
    }
    
    if (images.length === 0) return;
    
    this.currentImages = images.map(img => ({
      src: img.src.replace('width=400', 'width=1200').replace('width=800', 'width=1200'),
      alt: img.alt
    }));

    // Finde aktuelles Bild (verschiedene "hidden" Klassen)
    const visibleImage = images.find(img => !img.classList.contains('visually-hidden') && !img.classList.contains('hidden'));
    this.currentIndex = visibleImage ? parseInt(visibleImage.dataset.imageIndex) || 0 : 0;

    this.lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
    this.updateLightboxImage();
  }

  closeLightbox() {
    this.lightbox.classList.remove('active');
    document.body.style.overflow = '';
  }

  navigate(direction) {
    this.currentIndex += direction;
    
    if (this.currentIndex < 0) {
      this.currentIndex = this.currentImages.length - 1;
    } else if (this.currentIndex >= this.currentImages.length) {
      this.currentIndex = 0;
    }
    
    this.updateLightboxImage();
  }

  updateLightboxImage() {
    const img = this.lightbox.querySelector('.teamwear-lightbox__image');
    const current = this.lightbox.querySelector('.teamwear-lightbox__current');
    const total = this.lightbox.querySelector('.teamwear-lightbox__total');
    const prevBtn = this.lightbox.querySelector('.teamwear-lightbox__nav-btn--prev');
    const nextBtn = this.lightbox.querySelector('.teamwear-lightbox__nav-btn--next');

    if (this.currentImages[this.currentIndex]) {
      img.src = this.currentImages[this.currentIndex].src;
      img.alt = this.currentImages[this.currentIndex].alt;
      current.textContent = this.currentIndex + 1;
      total.textContent = this.currentImages.length;
    }

    const hasMultiple = this.currentImages.length > 1;
    prevBtn.style.display = hasMultiple ? 'flex' : 'none';
    nextBtn.style.display = hasMultiple ? 'flex' : 'none';
  }
}

// Initialize Lightbox IMMER (auch ohne Calculator!)
if (typeof window.teamwearLightboxInitialized === 'undefined') {
  window.teamwearLightboxInitialized = false;
}

if (!window.teamwearLightboxInitialized) {
  window.teamwearLightboxInitialized = true;
  
  const initLightbox = () => {
    if (!window.teamwearLightbox) {
      window.teamwearLightbox = new TeamwearLightbox();
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightbox);
  } else {
    initLightbox();
  }
}

// Initialize Calculator (nur wenn Config existiert)
if (typeof window.teamwearCalculatorInitialized === 'undefined') {
  window.teamwearCalculatorInitialized = false;
}

if (!window.teamwearCalculatorInitialized) {
  window.teamwearCalculatorInitialized = true;
  
  const initCalculator = () => {
    if (window.teamwearConfig?.sectionId && !window.teamwearCalculator) {
      try {
        window.teamwearCalculator = new TeamwearCalculator(window.teamwearConfig.sectionId);
      } catch (error) {
        console.error('TeamwearCalculator initialization failed:', error);
      }
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculator);
  } else {
    initCalculator();
  }
}
